import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import { EXPORT_MESSAGES } from "./constants";

interface ExportErrorDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: React.ReactNode;
  zIndex?: number;
}

export const ExportErrorDialog: React.FC<ExportErrorDialogProps> = ({
  open,
  onClose,
  title,
  message,
  zIndex = 1, // Default zIndex if not provided
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + zIndex,
      }}
    >
      <DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center">
            <Typography variant="h5">{title}</Typography>
          </Stack>
          <IconButton
            size="small"
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3 }}>
        {typeof message === "string" ? (
          <Typography variant="body2">{message}</Typography>
        ) : (
          message
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          size="small"
        >
          {EXPORT_MESSAGES.BUTTONS.CLOSE}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
